import { ref } from 'vue';
import {
  AbstractQueryParams,
  QueryBoolean,
  QueryNumber,
  QueryNumberArray,
  QueryString,
} from 'SharedDir/common/composables/useQueryString';

export type Filters = {
  groupId: number | null;
  name: string | null;
  kindId: number | null;
  typeId: number | null;
  formId: number | null;
  municipalAreas: number[] | null;
  segments: number[] | null;
  applicationStartsFrom: string | null;
  applicationStartsTo: string | null;
  isOutside: boolean | null;
  isInformation: boolean | null;
};

export function usePublicServicesFilters() {
  const defaultFilterParams = (): Filters => ({
    groupId: null,
    name: null,
    kindId: null,
    typeId: null,
    formId: null,
    municipalAreas: null,
    segments: null,
    applicationStartsFrom: null,
    applicationStartsTo: null,
    isOutside: null,
    isInformation: null,
  });

  const filterParams = ref<Filters>(defaultFilterParams());

  const sanitizeQueryFilterParams = () => ({
    groupId: QueryNumber,
    name: QueryString,
    kindId: QueryNumber,
    typeId: QueryNumber,
    formId: QueryNumber,
    municipalAreas: QueryNumberArray,
    segments: QueryNumberArray,
    applicationStartsFrom: QueryString,
    applicationStartsTo: QueryString,
    isOutside: QueryBoolean,
    isInformation: QueryBoolean,
  });

  return {
    filterParams,
    defaultFilterParams,
    sanitizeQueryFilterParams,
  };
}
